<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data">
      <template #suffix>
        <!-- <convert-excel
          class="btn btn-success"
          :data="excel_json.data"
          :fields="excel_json.fields"
          :worksheet="excel_json.worksheet"
          :name="excel_json.name"
          :type="excel_json.type"
          :before-generate="exportCsv"
        >
          匯出CSV
        </convert-excel> -->
        <convert-excel
          class="btn btn-success"
          :data="excel_json.data"
          :fields="excel_json.fields"
          :table="excel_json.table"
          :worksheet="excel_json.worksheet"
          :name="excel_json.name"
          :type="excel_json.type"
          :before-generate="() => exportExcel()"
        >
          匯出Excel
        </convert-excel>
      </template>
    </bread-crumb>

    <div class="operate">
      <b-form-group label-cols="auto" label-cols-lg="auto" label="顯示方式">
        <b-form-radio-group
          class="d-flex align-items-center h-100"
          v-model="search.type"
          :options="options.type"
        ></b-form-radio-group>
      </b-form-group>

      <div class="d-flex align-items-center justify-content-between mb-4">
        <b-form-group class="mb-0" label-cols="auto" label-cols-lg="auto" label="發放日期">
          <div class="d-flex">
            <date-picker
              class="mr-2"
              v-model="search.pay_at_S"
              :position="'left'"
              placeholder="開始"
            ></date-picker>

            <date-picker
              class="mr-2"
              v-model="search.pay_at_E"
              :position="'left'"
              placeholder="結束"
            ></date-picker>

            <b-button variant="primary" @click="searchDeceasedClaimForm()">查詢</b-button>
          </div>
        </b-form-group>
      </div>
    </div>

    <tables-page
      :tableData="data.table_data"
      :tableFields="tableFields"
      v-on:result="getMember"
    >
      <template #cell(no)="row">
        {{ countNoNum(data.page, row.index) }}
      </template>

      <template #cell(join_date)="row">
        {{ convertRocDate(row.item.join_date) }}
      </template>

      <template #cell(dead_at)="row">
        {{ convertRocDate(row.item.dead_at) }}
      </template>

      <template #cell(claim_seniority)="row">
        {{ row.item.claim_seniority }}個月
      </template>

      <template #cell(pay_at)="row">
        {{ convertRocDate(row.item.pay_at) }}
      </template>

      <template #custom-foot>
        <tr>
          <td class="text-right" colspan="8">
            總計
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'pay_total') }}
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'claim_un_condolence') }}
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'claim_real_condolence') }}
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'claim_unpay') }}
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'claim_other_reduce') }}
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'claim_other_add') }}
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'claim_behalf') }}
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'claim_behalf_fee') }}
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'claim_cash_advance') }}
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'claim_cash_advance_fee') }}
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'claim_condolence') }}
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'claim_stable') }}
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'claim_administrative') }}
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'claim_need_pay') }}
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'claim_reduce_sum') }}
          </td>

          <td class="text-center">
            {{ calculateRowsSum(data.table_data, 'claim_pay') }}
          </td>
        </tr>
      </template>
    </tables-page>

  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import TablesPage from "@/components/layouts/TablesPage";
import contractApi from "@/models/API/contractApi";
import datePicker from '@/components/common/DatePicker';
import { countNoNum, convertRocDate, convertDateFormat, calculateRowsSum, getTodayDate } from "@/models/HELPERS/common.js";
import ConvertExcel from "@/components/common/ConvertExcel";

export default {
  name: 'deceasedClaimForm',
  components: {
    BreadCrumb,
    TablesPage,
    datePicker,
    ConvertExcel
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '理賠', url: '', isActive: true },
          { name: '身故請領表', url: '', isActive: false }
        ]
      },
      options: {
        type: [
           {
            value: 0,
            text: '主管版'
          },
          {
            value: 1,
            text: '完整版'
          },
          {
            value: 2,
            text: '報稅版'
          },
        ],
      },
      search: {
        type: 0,
        pay_at_S: '',
        pay_at_E: '',
      },
      data: {
        table_data: [],
        table_sort: {
          sortBy: '',
          sort: ''
        },
        page: {},
      },
      excel_json: {
        fields: {},
        data: [],
        table: '',
        worksheet: 'My Worksheet',
        name: '身故請領表.xls',
        type: 'table'
      }
    }
  },
  // 在路由離開前觸發邏輯
  beforeRouteLeave (to, from, next) {
    sessionStorage.removeItem("deceasedClaimForm");

    next();
  },
  computed: {
    tableFields() {
      let fields = [];

      if (this.search.type === 0) {
        fields = [
          {
            key: "no",
            label: "No"
          },
          {
            key: "number",
            label: "契約編號",
            sortable: true
          },
          {
            key: "sales_name",
            label: "業務姓名",
            sortable: true
          },
          {
            key: "member_name",
            label: "互助人",
            sortable: true
          },
          {
            key: "join_date",
            label: "入會日期",
            sortable: true
          },
          {
            key: "dead_at",
            label: "身故日期",
            sortable: true
          },
          {
            key: "beneficiary_name",
            label: "受款人",
            sortable: true
          },
          {
            key: "claim_seniority",
            label: "實際年資"
          },
          {
            key: "pay_total",
            label: "已繳月費"
          },
          {
            key: "claim_un_condolence",
            label: "慰問金"
          },
          {
            key: "claim_real_condolence",
            label: "實發慰問金"
          },
          {
            key: "claim_unpay",
            label: "未繳款項"
          },
          {
            key: "claim_other_reduce",
            label: "自訂扣款"
          },
          {
            key: "claim_other_add",
            label: "自訂加款"
          },
          {
            key: "claim_behalf",
            label: "墊繳金額"
          },
          {
            key: "claim_behalf_fee",
            label: "墊繳手續費"
          },
          {
            key: "claim_cash_advance",
            label: "預領金額"
          },
          {
            key: "claim_cash_advance_fee",
            label: "預領手續費"
          },
          {
            key: "claim_condolence",
            label: "慰問基金"
          },
          {
            key: "claim_stable",
            label: "安定基金"
          },
          {
            key: "claim_administrative",
            label: "行政費"
          },
          // {
          //   key: "claim_year",
          //   label: "年費"
          // },
          // {
          //   key: "claim_defferred",
          //   label: "遞延金額"
          // },
          {
            key: "claim_need_pay",
            label: "應領金額"
          },
          {
            key: "claim_reduce_sum",
            label: "應扣除金額合計"
          },
          {
            key: "claim_pay",
            label: "實領金額"
          },
          {
            key: "remark",
            label: "註記"
          },
        ];
      } else if (this.search.type === 1) {
        fields = [
          {
            key: "no",
            label: "No"
          },
          {
            key: "number",
            label: "契約編號",
            sortable: true
          },
          {
            key: "sales_name",
            label: "業務姓名",
            sortable: true
          },
          {
            key: "member_name",
            label: "互助人",
            sortable: true
          },
          {
            key: "join_date",
            label: "入會日期",
            sortable: true
          },
          {
            key: "dead_at",
            label: "身故日期",
            sortable: true
          },
          {
            key: "beneficiary_name",
            label: "受款人",
            sortable: true
          },
          {
            key: "claim_seniority",
            label: "實際年資"
          },
          {
            key: "pay_total",
            label: "已繳月費"
          },
          {
            key: "claim_un_condolence",
            label: "慰問金"
          },
          {
            key: "claim_real_condolence",
            label: "實發慰問金"
          },
          {
            key: "claim_unpay",
            label: "未繳款項"
          },
          {
            key: "claim_other_reduce",
            label: "自訂扣款"
          },
           {
            key: "claim_other_add",
            label: "自訂加款"
          },
          {
            key: "claim_behalf",
            label: "墊繳金額"
          },
          {
            key: "claim_behalf_fee",
            label: "墊繳手續費"
          },
          {
            key: "claim_cash_advance",
            label: "預領金額"
          },
          {
            key: "claim_cash_advance_fee",
            label: "預領手續費"
          },
          {
            key: "claim_condolence",
            label: "慰問基金"
          },
          {
            key: "claim_stable",
            label: "安定基金"
          },
          {
            key: "claim_administrative",
            label: "行政費"
          },
          {
            key: "claim_need_pay",
            label: "應領金額"
          },
          {
            key: "claim_reduce_sum",
            label: "應扣除金額合計"
          },
          {
            key: "claim_pay",
            label: "實領金額"
          },
          {
            key: "pay_at",
            label: "發放日期",
            sortable: true
          },
          {
            key: "remark",
            label: "註記"
          },
          {
            key: "claim_unpay_remark",
            label: "未繳款項描述"
          },
          {
            key: "claim_other_reduce_name",
            label: "自訂扣款名稱"
          },
        ];
      } else if (this.search.type === 2) {
        fields = [
          {
            key: "no",
            label: "No"
          },
          {
            key: "number",
            label: "契約編號",
            sortable: true
          },
          {
            key: "sales_name",
            label: "業務姓名",
            sortable: true
          },
          {
            key: "member_name",
            label: "互助人",
            sortable: true
          },
          {
            key: "join_date",
            label: "入會日期",
            sortable: true
          },
          {
            key: "dead_at",
            label: "身故日期",
            sortable: true
          },
          {
            key: "beneficiary_name",
            label: "受款人",
            sortable: true
          },
          {
            key: "claim_seniority",
            label: "實際年資"
          },
          {
            key: "pay_total",
            label: "已繳月費"
          },
          {
            key: "claim_un_condolence",
            label: "慰問金"
          },
          {
            key: "claim_real_condolence",
            label: "實發慰問金"
          },
          {
            key: "claim_unpay",
            label: "未繳款項"
          },
          {
            key: "claim_other_reduce",
            label: "自訂扣款"
          },
          {
            key: "claim_other_add",
            label: "自訂加款"
          },
          {
            key: "claim_behalf",
            label: "墊繳金額"
          },
          {
            key: "claim_behalf_fee",
            label: "墊繳手續費"
          },
          {
            key: "claim_cash_advance",
            label: "預領金額"
          },
          {
            key: "claim_cash_advance_fee",
            label: "預領手續費"
          },
          {
            key: "claim_condolence",
            label: "慰問基金"
          },
          {
            key: "claim_stable",
            label: "安定基金"
          },
          {
            key: "claim_administrative",
            label: "行政費"
          },
          {
            key: "claim_need_pay",
            label: "應領金額"
          },
          {
            key: "claim_reduce_sum",
            label: "應扣除金額合計"
          },
          {
            key: "claim_pay",
            label: "實領金額"
          },
          {
            key: "remark",
            label: "註記"
          },
          {
            key: "beneficiary_ID_number",
            label: "受款人身分證"
          },
          {
            key: "pay_name",
            label: "要助人"
          },
          {
            key: "pay_at",
            label: "發放日期"
          },
          {
            key: "pay_Haddress",
            label: "要助人戶籍地址"
          },
          {
            key: "legal_heir",
            label: "法定繼承人"
          },
        ];
      }

      return fields;
    }
  },
  mounted() {
    this.contractApi = new contractApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.data.page = Object.assign({}, this.contractApi.page);

      const deceasedClaimForm = sessionStorage.getItem("deceasedClaimForm") || null;

      if (deceasedClaimForm) {
        this.search = JSON.parse(deceasedClaimForm);

        this.getMember();
      }
    },
    countNoNum,
    convertRocDate,
    calculateRowsSum,
    // 查詢契約
    getMember(pageIndex = null, sortBy = '', sort = '') {
      if (sortBy) this.data.table_sort.sortBy = sortBy;
      if (sort) this.data.table_sort.sort = sort;

      const params = {
        ...this.search,
        'pay_status': 1,
        'sortBy': this.data.table_sort.sortBy,
        'sort': this.data.table_sort.sort
      };
      this.contractApi.getMember((response) => {
        const res = response.data;

        this.data.page.totalCount = res.total; // 總筆數
        this.data.table_data = res.data.map(item => {
          return {
            ...item,
            body_tr_bg: this.getRightsInterests(item.status).bg_class,
            legal_heir: ''
          }
        });
      }, params)
    },
    // 取得權益文字
    getRightsInterests(status = 0) {
      let text = '', bg_class = '';

      switch (status) {
        case 0:
          text = '正常';
          bg_class = 'bg-normal';
          break;
        case 1:
          text = '身故';
          bg_class = 'bg-died';
          break;
        case 2:
          text = '停效';
          bg_class = 'bg-stop';
          break;
        case 3:
          text = '除會';
          bg_class = 'bg-fail';
          break;
        case 4:
          text = '墊繳';
          bg_class = 'bg-close';
          break;
      }

      return { text, bg_class };
    },
    // 查詢身故請領表
    searchDeceasedClaimForm() {
      const required =
        ['pay_at_S',
        'pay_at_E'];
      const data = this.search;
      const status = required.every(item => data[item] != null && data[item] !== '');

      if (!status) {
        const result = { message: '條件請選擇完整', title: '身故請領表' };
        this.contractApi.toast(() => {}, result, false);

        return;
      }

      sessionStorage.setItem("deceasedClaimForm", JSON.stringify(this.search));
      this.getMember();
    },
    // 匯出身故請領表
    exportCsv() {
      if (this.data.table_data.length === 0) {
        const result = { message: '無資料，請重新選擇條件!!', title: '身故請領表' };
        this.contractApi.toast(() => {}, result, false);

        return;
      }

      let fields = {}, data = [];

      this.tableFields.forEach(fields_item => {
        fields = {
          ...fields,
          [fields_item.label]: fields_item.key
        }
      })

      this.data.table_data.forEach((data_item, index) => {
        let temp_data = {};

        this.tableFields.forEach(fields_item => {
          if (fields_item.key === 'no') {
            temp_data = {
              ...temp_data,
              [fields_item.key]: countNoNum(this.data.page, index)
            }
          } else if (fields_item.key === 'join_date' || fields_item.key === 'dead_at' || fields_item.key === 'pay_at') {
            temp_data = {
              ...temp_data,
              [fields_item.key]: data_item[fields_item.key] ? convertDateFormat(data_item[fields_item.key], false) : ''
            }
          } else if (fields_item.key === 'claim_seniority') {
            temp_data = {
              ...temp_data,
              [fields_item.key]: data_item.claim_seniority ? `${data_item.claim_seniority}月 (${data_item.seniority_day}天)` : ''
            }
          } else {
            temp_data = {
            ...temp_data,
              [fields_item.key]: data_item[fields_item.key] !== null ? data_item[fields_item.key] : ''
            }
          }
        })

        data.push(temp_data)
      })

      this.excel_json.fields = fields;
      this.excel_json.data = data;
    },
    // 匯出身故請領表
    exportExcel() {
      if (this.data.table_data.length === 0) {
        const result = { message: '無資料，請重新選擇條件!!', title: '身故請領表' };
        this.contractApi.toast(() => {}, result, false);

        return;
      }

      return new Promise(async(resolve, reject) => {
        const type = this.search.type;
        this.excel_json.table = '';

        switch (type) {
          case 0:
            await this.managerTableFormatHandler();

            resolve(true);
            break;
          case 1:
            await this.allTableFormatHandler();

            resolve(true);
            break;
          case 2:
            await this.taxTableFormatHandler();

            resolve(true);
            break;
          default:
            await this.managerTableFormatHandler();

            resolve(true);
        }
      })
    },
    // 主管版表格格式處理
    managerTableFormatHandler() {
      return new Promise((resolve, reject) => {
        const pay_at_S = convertRocDate(this.search.pay_at_S, false, true);
        const pay_at_E = convertRocDate(this.search.pay_at_E, false, true);

        let thead = `<thead>
                      <tr>
                        <th align="left">永豐網路平台股份有限公司身故請領表</th>
                      </tr>
                      <tr>
                        <th align="left">發放日期：${pay_at_S.year}年${pay_at_S.month}月${pay_at_S.day}日 ~ ${pay_at_E.year}年${pay_at_E.month}月${pay_at_E.day}日</th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th>製表日：${getTodayDate(true)}</th>
                      </tr>
                      <tr>
                    `,
        tbody = '<tbody>',
        tfoot = `<tfoot>
                  <tr></tr>
                  <tr></tr>
                  <tr></tr>
                  <tr></tr>
                  <tr></tr>
                  <tr></tr>
                  <tr>
                    <td></td>
                    <td colspan="3" align="center" style="border: 1px solid #000;">董事長</td>
                    <td colspan="3" align="center" style="border: 1px solid #000;">主管</td>
                    <td colspan="3" align="center" style="border: 1px solid #000;">審核</td>
                    <td colspan="3" align="center" style="border: 1px solid #000;">經辦人</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td colspan="3" style="border: 1px solid #000;"><br style="mso-data-placement: same-cell;"><br style="mso-data-placement: same-cell;"><br style="mso-data-placement: same-cell;"></td>
                    <td colspan="3" style="border: 1px solid #000;"><br style="mso-data-placement: same-cell;"><br style="mso-data-placement: same-cell;"><br style="mso-data-placement: same-cell;"></td>
                    <td colspan="3" style="border: 1px solid #000;"><br style="mso-data-placement: same-cell;"><br style="mso-data-placement: same-cell;"><br style="mso-data-placement: same-cell;"></td>
                    <td colspan="3" style="border: 1px solid #000;"><br style="mso-data-placement: same-cell;"><br style="mso-data-placement: same-cell;"><br style="mso-data-placement: same-cell;"></td>
                  </tr>
                </tfoot>`;

        this.tableFields.forEach(fields_item => {
          thead += `<th style="background: #F5F6FA;">${fields_item.label}</th>`;
        })

        thead += '</tr></thead>';

        this.data.table_data.forEach((item, index) => {
          tbody += '<tr>';

          this.tableFields.forEach(value => {
            if (value.key === 'no') {
              tbody += `<td>${countNoNum(this.data.page, index)}</td>`;
            } else if (value.key === 'join_date' || value.key === 'dead_at' || value.key === 'pay_at') {
              tbody += `<td style="mso-number-format:\'yyyy-mm-dd\'">${item[value.key]}</td>`;
            } else if (value.key === 'claim_seniority') {
              tbody += `<td>${item[value.key] !== null ? `${item[value.key]}個月` : ''}</td>`;
            } else {
              tbody += `<td>${item[value.key] !== null ? item[value.key] : ''}</td>`;
            }
          })

          tbody += '</tr>';
        })

        tbody += `<tr></tr>
                  <tr style="color: red;">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td align="right">總計</td>
                    <td>${calculateRowsSum(this.data.table_data, 'pay_total')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_un_condolence')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_real_condolence')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_unpay')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_other_reduce')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_other_add')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_behalf')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_behalf_fee')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_cash_advance')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_cash_advance_fee')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_condolence')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_stable')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_administrative')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_need_pay')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_reduce_sum')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_pay')}</td>
                  </tr>`

        tbody += '</tbody>';

        this.excel_json.table = thead + tbody + tfoot;
        this.excel_json.name = '身故請領表(主管版).xls'

        resolve(true);
      })
    },
    // 完整版表格格式處理
    allTableFormatHandler() {
      return new Promise((resolve, reject) => {
        const pay_at_S = convertRocDate(this.search.pay_at_S, false, true);
        const pay_at_E = convertRocDate(this.search.pay_at_E, false, true);

        let thead = `<thead>
                      <tr>
                        <th align="left">永豐網路平台股份有限公司身故請領表</th>
                      </tr>
                      <tr>
                        <th align="left">發放日期：${pay_at_S.year}年${pay_at_S.month}月${pay_at_S.day}日 ~ ${pay_at_E.year}年${pay_at_E.month}月${pay_at_E.day}日</th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th>製表日：${getTodayDate(true)}</th>
                      </tr>
                      <tr>
                    `,
        tbody = '<tbody>'

        this.tableFields.forEach(fields_item => {
          thead += `<th style="background: #F5F6FA;">${fields_item.label}</th>`;
        })

        thead += '</tr></thead>';

        this.data.table_data.forEach((item, index) => {
          tbody += '<tr>';

          this.tableFields.forEach(value => {
            if (value.key === 'no') {
              tbody += `<td>${countNoNum(this.data.page, index)}</td>`;
            } else if (value.key === 'join_date' || value.key === 'dead_at' || value.key === 'pay_at') {
              tbody += `<td style="mso-number-format:\'yyyy-mm-dd\'">${item[value.key]}</td>`;
            } else if (value.key === 'claim_seniority') {
              tbody += `<td>${item[value.key] !== null ? `${item[value.key]}個月` : ''}</td>`;
            } else {
              tbody += `<td>${item[value.key] !== null ? item[value.key] : ''}</td>`;
            }
          })

          tbody += '</tr>';
        })

        tbody += `<tr></tr>
                  <tr style="color: red;">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td align="right">總計</td>
                    <td>${calculateRowsSum(this.data.table_data, 'pay_total')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_un_condolence')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_real_condolence')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_unpay')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_other_reduce')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_other_add')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_behalf')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_behalf_fee')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_cash_advance')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_cash_advance_fee')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_condolence')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_stable')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_administrative')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_need_pay')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_reduce_sum')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_pay')}</td>
                  </tr>`

        tbody += '</tbody>';

        this.excel_json.table = thead + tbody;
        this.excel_json.name = '身故請領表(完整版).xls'

        resolve(true);
      })
    },
    // 報稅版表格格式處理
    taxTableFormatHandler() {
      return new Promise((resolve, reject) => {
        const pay_at_S = convertRocDate(this.search.pay_at_S, false, true);
        const pay_at_E = convertRocDate(this.search.pay_at_E, false, true);

        let thead = `<thead>
                      <tr>
                        <th align="left">永豐網路平台股份有限公司身故請領表</th>
                      </tr>
                      <tr>
                        <th align="left">發放日期：${pay_at_S.year}年${pay_at_S.month}月${pay_at_S.day}日 ~ ${pay_at_E.year}年${pay_at_E.month}月${pay_at_E.day}日</th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th>製表日：${getTodayDate(true)}</th>
                      </tr>
                      <tr>
                    `,
        tbody = '<tbody>'

        this.tableFields.forEach(fields_item => {
          thead += `<th style="background: #F5F6FA;">${fields_item.label}</th>`;
        })

        thead += '</tr></thead>';

        this.data.table_data.forEach((item, index) => {
          tbody += '<tr>';

          this.tableFields.forEach(value => {
            if (value.key === 'no') {
              tbody += `<td>${countNoNum(this.data.page, index)}</td>`;
            } else if (value.key === 'join_date' || value.key === 'dead_at' || value.key === 'pay_at') {
              tbody += `<td style="mso-number-format:\'yyyy-mm-dd\'">${item[value.key]}</td>`;
            } else if (value.key === 'claim_seniority') {
              tbody += `<td>${item[value.key] !== null ? `${item[value.key]}個月` : ''}</td>`;
            } else {
              tbody += `<td>${item[value.key] !== null ? item[value.key] : ''}</td>`;
            }
          })

          tbody += '</tr>';
        })

        tbody += `<tr></tr>
                  <tr style="color: red;">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td align="right">總計</td>
                    <td>${calculateRowsSum(this.data.table_data, 'pay_total')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_un_condolence')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_real_condolence')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_unpay')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_other_reduce')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_other_add')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_behalf')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_behalf_fee')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_cash_advance')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_cash_advance_fee')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_condolence')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_stable')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_administrative')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_need_pay')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_reduce_sum')}</td>
                    <td>${calculateRowsSum(this.data.table_data, 'claim_pay')}</td>
                  </tr>`

        tbody += '</tbody>';

        this.excel_json.table = thead + tbody;
        this.excel_json.name = '身故請領表(報稅版).xls'

        resolve(true);
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.operate {
  display: flex;
  align-items: left;
  flex-direction: column;
  white-space: nowrap;

}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/deceasedClaimForm.vue